import RootStore from '@stores/RootStore';
import DisturbanceStore from '@stores/DisturbanceStore';
import { DisturbanceType } from '@config/DisturbanceConfig';

export default class IncidentDisturbanceStore extends DisturbanceStore {

  public constructor(rootStore: RootStore) {
    super(rootStore);
    this.apiCall = DisturbanceType.IncidentDisturbanceInfo;
  }
}
